var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgot-password fullWidth"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',[_c('vue-form',{ref:"form",attrs:{"options":{
            permalink: 'forgotPasswordEmail'
          }}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('router-link',{staticClass:"btn btn-secondary btn-sm",attrs:{"to":{ path : '/' }}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back to Login ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5ff6234","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 1312
// module chunks = 1